<template>
  <div>
    <b-container fluid class="gen-header">
      <b-row>
        <b-col sm="12">
          <div class="childs">
            <div class="page-title">Contact Us</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <contact-page></contact-page>
  </div>
</template>

<script>
// @ is an alias to /src
import ContactPage from "@/components/ContactPage.vue";

export default {
  created() {
    document.title = "Contact Us";
  },
  name: "Contact",
  data() {
    return {
      drawer: true,
      images: {
        headImage: require("@/assets/bgparallax-01.jpg")
      },
      data: [],
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Contact Us",
          active: true
        }
      ]
    };
  },
  components: {
    "contact-page": ContactPage
  }
};
</script>
<style scoped></style>
